module.exports = __webpack_public_path__ + "static/media/blueberries-raspberries.a889acdb.jpg";